import { DatePickerDay } from './date-picker-day';

export class DatePickerWeek {
  public days: DatePickerDay[] = [];
  public week: number;

  constructor(week: number) {
    this.week = week;
  }

  public getLastDay(): Date {
    return this.days[6].date;
  }

  public getFirstDay(): Date {
    return this.days[0].date;
  }

  toString(): string {
    return this.week <= 9 ? `0${this.week}` : this.week + '';
  }
}
